import React, { useEffect, useState } from "react";
import { Button, Dropdown, Table } from "react-bulma-components";
import { Icon, IconText } from "../common/Icon";
import { UilEllipsisV, UilPlus, UilTrash } from "@iconscout/react-unicons";
import ProjectSection from "./ProjectSection";
import { MODAL_ADD_SHOPPING_ITEM } from "./ProjectConstants";
import { fetcher } from "../utils/fetch";

export default function ProjectShoppingItems({ shoppingItems, onTriggerDelete, onTriggerModal, project }) {
    const actions = (
        <>
            <Button size="small" colorVariant="light" onClick={ () => onTriggerModal(MODAL_ADD_SHOPPING_ITEM) }>
                <IconText icon={ UilPlus } size={ 12 }>
                    Add shopping item
                </IconText>
            </Button>
        </>
    );

    const items = shoppingItems.map(item => {
        return <ShoppingItem key={ item.id } item={ item } onDelete={ onTriggerDelete } project={ project }/>
    });

    return (
        <ProjectSection title="Shopping" itemCount={ shoppingItems.length } noItemsText="No shopping items yet!"
                        actions={ actions }>
            <Table size="fullwidth">
                <tbody>
                { items }
                </tbody>
            </Table>
        </ProjectSection>
    )
}

function ShoppingItem({ item, onDelete, project }) {
    const [checked, setChecked] = useState(item.done);
    useEffect(() => {
        setChecked(item.done);
    }, [item]);

    const onClickDropdownItem = async (value) => {
        if (value === 'delete') {
            await onDelete(`/api/projects/${ project.id }/shopping/${ item.id }`);
        }
    }

    const onChangeShoppingItem = async (e) => {
        const isChecked = e.currentTarget.checked;

        setChecked(isChecked);

        try {
            await fetcher(`/api/projects/${ project.id }/shopping/${ item.id }`, {
                method: 'PATCH',
                body: JSON.stringify({
                    done: isChecked,
                    done_at: isChecked ? new Date().toISOString() : null
                })
            });
        } catch (e) {
            // TODO
            console.error(e);
        }
    }

    return (
        <tr key={ item.id }>
            <td className="is-flex">
                <label className="is-flex-grow-1">
                    {/* TODO: onChange */ }
                    <input className="mr-2" type="checkbox" checked={ checked }
                           onChange={ onChangeShoppingItem }/> { item.item }
                </label>

                <span className="ml-2 has-text-right">
                        <Dropdown onChange={ onClickDropdownItem } color="ghost" hoverable right
                                  label={ <Icon icon={ UilEllipsisV }/> }>
                            <Dropdown.Item renderAs="a" value="delete">
                                <IconText className="has-text-danger" icon={ UilTrash }>
                                    Delete
                                </IconText>
                            </Dropdown.Item>
                        </Dropdown>
                    </span>
            </td>
        </tr>
    );
}
